export default "__VITE_ASSET__ClVSlRMp__"